/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import embedManagementRootReducer from 'state/reducers/embedsState/embedManagementState/root';
import embedsStatus from 'state/reducers/embedsState/embeds_status';



/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE: ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const embedsStateRootReducer = combineReducers({
    embedsStatus,
    embedManagementState: embedManagementRootReducer
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedsStateRootReducer;
